import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

// i18n
import { useI18n } from 'vue-i18n'
import useThemeClassName from '@/hooks/useThemeClassName'

// Types
import type { Props } from '@/components/ui/Button'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    type: { default: 'button' },
    theme: {},
    to: { default: null }
  },
  setup(__props: any) {

const { t } = useI18n()

// Use
const props = __props

// Computed
const themeClassName = computed(() => useThemeClassName('ui-button', props.theme))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), _mergeProps({ class: "ui-button" }, _ctx.$attrs, {
    to: _ctx.to,
    class: [themeClassName.value]
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prepend"),
      _renderSlot(_ctx.$slots, "default"),
      _renderSlot(_ctx.$slots, "append")
    ]),
    _: 3
  }, 16, ["to", "class"]))
}
}

})